<template>
  <div>
    <div v-if="question.image" class="question-image">
      <img :src="disableCache(question.image)" class="image-content" />
      <h2 class="image-title">{{ question.texts[lang] }}</h2>
    </div>

    <h2 v-else class="question-only-title">{{ question.texts[lang] }}</h2>
  </div>
</template>

<script>
import { disableCache } from '@/components/utils';
import { mapGetters } from 'vuex';

export default {
  name: 'question-title',
  props: {
    question: Object
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' })
  },
  methods: {
    disableCache
  }
};
</script>

<style lang="scss" scoped>
.question-image {
  margin-bottom: 20px;
  background-color: #fff;
  .image-content {
    width: 100%;
  }
  .image-title {
    margin-top: 10px;
    text-align: center;
    font-weight: 600;
  }
}

.question-only-title {
  margin-bottom: 40px;
  font-size: 17px;
  text-align: center;
  font-weight: 600;
}
</style>
